module.exports = __webpack_public_path__ + "static/media/igork.aeb42958.jpg";